import GroupRadioFilter from "./filters/group-radio-filter.js";
import GroupRadioRatingsFilter from "./filters/group-radio-ratings-filter.js";
import SelectFilter from "./filters/select-filter.js";
import SelectRatingsFilter from "./filters/select-ratings-filter.js";
import {tracking as barkTrackingLogEvent} from "@bark/bark-core";
import {useNamespace, _t} from '@bark/bark-core';

export default async function(eventEmitter){
    await useNamespace('buyer_seller-list_filters')

	const {Handlebars} = window;

	const domElements = {
		filtersHeaderMain: 'list-filters-header',
		filtersHeaderContainerId: 'list-filters-header-container',
		filtersSubHeaderContainerId: 'list-filters-sub-header-container',
		filtersModalId: 'list-mobile-filters-modal',
        filtersModalContainerId: 'list-mobile-filters-modal-container',
        filtersModalHeaderContainerId: 'list-mobile-filters-modal-header-container',
		filtersModalFooterContainerId: 'list-mobile-filters-modal-footer-container',
		filtersDiscardModalId: 'list-mobile-filters-discard-modal',
	};

	const hbTemplates = {
		filtersHeader: Handlebars.compile(document.getElementById('list-filters-header-template').innerHTML),
		filtersSubHeader: Handlebars.compile(document.getElementById('list-filters-sub-header-template').innerHTML),
		filtersModalHeader: Handlebars.compile(document.getElementById('list-mobile-filters-modal-header-template').innerHTML),
		filtersModalFooter: Handlebars.compile(document.getElementById('list-mobile-filters-modal-footer-template').innerHTML),
	}

	const filterGroups = {
		mobile: {
			filters:{
				reviews_score: {title: 'Ratings', type: GroupRadioRatingsFilter(), children: [], previewChildren: []},
				distance: {title: 'Location', type: GroupRadioFilter(), children: [], previewChildren: [], countryIds: [236]},
				median_response_time: {title: 'Response time', type: GroupRadioFilter(), children: [], previewChildren: []},
			},
		},
		desktop: {
			filters:{
				reviews_score: {title: 'Ratings', type: SelectRatingsFilter(), children: []},
				distance: {title: 'Location', type: SelectFilter(), children: [], countryIds: [236]},
				median_response_time: {title: 'Response time', type: SelectFilter(), children: [], prefix: _t('buyer_seller-list_filters:responds-prefix')},
			}
		}
	};

	const state = {
		pagination: {},
		buyerCountryId: null
	};

	const previewState = {
		pagination: {},
		filtersChanged: false
	};

	const updateMobileFiltersPreviewData = (data) => {
		updatePreviewPagination(data);
		updatePreviewFiltersForGroup(data, 'mobile');
	};

	const drawPreviewMobileFiltersModal = () => {
		buildMobileFiltersModal(true);
		initFilters();
		bindFilterListners();
		bindListners();
	};

	const updatePreviewPagination = ({meta: { 'pagination': paginationData }}) => {
		previewState.pagination = paginationData;
	};

	const updatePreviewFiltersForGroup = ({meta: { 'filters': postFiltersData }}, group) => {
		postFiltersData.forEach((postFilter) => {
			if(filterGroups[group].filters.hasOwnProperty(postFilter.id) && postFilter.children.length)
			{
				filterGroups[group].filters[postFilter.id].previewChildren = postFilter.children;
			}
		});
	};

	const setPreviewFiltersChangedStatus = (status) => {
		previewState.filtersChanged = status;
	};

	const shouldShowFiltersDiscardModal = () => {
		return previewState.filtersChanged && previewState.pagination?.total > 0;
	};

	const updateData = (data) => {
		updatePagination(data);
		updateFilters(data);
	};

	const draw = () => {
		if($(`#${domElements.filtersHeaderMain}`).length){
			handleNoFilteredMatches();
			buildMobileFiltersModal();
			buildHeader();
			initFilters();
			bindFilterListners();
			bindListners();
		}
	};

	const updateFilters = ({meta: { 'filters': postFiltersData }}) => {
		Object.keys(filterGroups).forEach((group) => {
			postFiltersData.forEach((postFilter) => {
				if(filterGroups[group].filters.hasOwnProperty(postFilter.id) && postFilter.children.length)
				{
					filterGroups[group].filters[postFilter.id].children = postFilter.children;
				}
			});
		});
	};

	const updatePagination = ({meta: { 'pagination': paginationData }}) => {
		state.pagination = paginationData;
	};

	const setPaginationModifier = (count = 0) => {
		state.paginationModifier = count;
	};

	const buildHeader = () => {
		let filtersHtml = getFiltersHtml('desktop');

		let headerHtml = hbTemplates.filtersHeader({
			matchesText: _t('buyer_seller-list_filters:header.number-of-matches', {
				count: getPaginationTotal(),
			}),
			filtersCountText: _t('buyer_seller-list_filters:header.filters-applied-count', {
				count: getCurrentFiltersAppliedCount(),
			}),
			appliedFiltersCount: getCurrentFiltersAppliedCount(),
			pagination: getPaginationObject(),
			filtersHtml,
		});

		let subHeaderHtml = hbTemplates.filtersSubHeader({
			pagination: getPaginationObject(),
			matchesText: _t('buyer_seller-list_filters:header.number-of-matches', {
				count: getPaginationTotal(),
			}),
		});

		$(`#${domElements.filtersHeaderContainerId}`).empty().append(headerHtml);
		$(`#${domElements.filtersSubHeaderContainerId}`).empty().append(subHeaderHtml);
	};

	const buildMobileFiltersModal = (preview = false) => {
		let filtersHtml = getFiltersHtml('mobile', preview);

		let modalHeaderHtml = hbTemplates.filtersModalHeader({
			filtersApplied: preview
				? getCurrentPreviewFiltersAppliedCount()
				: getCurrentFiltersAppliedCount(),
		});

		let modalFooterHtml = hbTemplates.filtersModalFooter({
			pagination: preview ? previewState.pagination : getPaginationObject(),
			buttonText: _t('buyer_seller-list_filters:filter-button', {
				count: getPaginationTotal(),
			}),
		});

		$(`#${domElements.filtersModalHeaderContainerId}`).empty().append(modalHeaderHtml);
		$(`#${domElements.filtersModalFooterContainerId}`).empty().append(modalFooterHtml);
		$(`#${domElements.filtersModalContainerId}`).empty().append(filtersHtml);
	};

	const bindFilterListners = () => {
		Object.keys(filterGroups).forEach((group) => {
			Object.keys(filterGroups[group].filters).forEach((filterKey) => {
				let filterData = filterGroups[group].filters[filterKey];
				if (showInBuyerCountry(filterData)) {
					let filterPrefix = filterData?.prefix;
					filterData.type.registerListner(eventEmitter, filterKey, group, filterPrefix);
				}
			});
		});

		$(document).click(function () {
			$('.filter-select-items').removeClass('d-block');
		});
	};

	const initFilters = () => {
		Object.keys(filterGroups).forEach((group) => {
			Object.keys(filterGroups[group].filters).forEach((filterKey) => {
				let filterData = filterGroups[group].filters[filterKey];
				if (showInBuyerCountry(filterData)) {
					let filterPrefix = filterData?.prefix;
					filterData.type.initFilter(filterKey, filterPrefix);
				}
			});
		});
	};

	const bindListners = () => {
		$('.js-show-mobile-filters')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				draw();
				setPreviewFiltersChangedStatus(false);
				$(`#${domElements.filtersModalId}`).modal('show');
				barkTrackingLogEvent(
					'seller-list-&-profile',
					'seller_list_filters - Filter view',
					{ project_id: getProjectHash(), filter_name: null },
				);
			});

		$('.js-reset-filters')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				eventEmitter.emit('filters.reset');
				barkTrackingLogEvent(
					'seller-list-&-profile',
					'seller_list_filters - Filters cleared',
					{ project_id: getProjectHash() },
				);
			});

		$('.js-mobile-reset-filters')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				setPreviewFiltersChangedStatus(true);
				eventEmitter.emit('filters.mobile.reset');
				barkTrackingLogEvent(
					'seller-list-&-profile',
					'seller_list_filters - Filters cleared',
					{ project_id: getProjectHash() },
				);
			});

		$('.js-see-results-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				eventEmitter.emit('filters.applied');
				$(`#${domElements.filtersModalId}`).modal('hide');
			});

		$('.js-close-mobile-filters-modal')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				shouldShowFiltersDiscardModal()
					? $(`#${domElements.filtersDiscardModalId}`).modal('show')
					: $(`#${domElements.filtersModalId}`).modal('hide');
			});

		$('.js-confim-discard-filters')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				$(`#${domElements.filtersDiscardModalId}`).modal('hide');
				$(`#${domElements.filtersModalId}`).modal('hide');
			});

		eventEmitter.on('sellerlistloading.start', () => {
			$('.js-see-results-btn .spinner-border').removeClass('d-none');
			$('.js-see-results-btn .button-text').addClass('d-none');
			disableFilters();
		});

		eventEmitter.on('sellerlistloading.finish', () => {});

		eventEmitter.on('filters.mobile.changed', () => {
			setPreviewFiltersChangedStatus(true);
		});

		stickyHeaderOnMobile();

		stickyModalHeader();

		closeMobileFiltersModalOnResize();
	};

	const getFilterKeys = () => {
		let group = getFilterGroup();
		return Object.keys(filterGroups[group].filters);
	};

	const getFilterGroup = () => {
		return $(window).width() < 992 ? 'mobile' : 'desktop';
	};

	const getCurrentFiltersAndValues = () => {
		let group = getFilterGroup();

		let filterObj = {};

		Object.keys(filterGroups[group].filters).forEach((filterKey) => {
			let filterData = filterGroups[group].filters[filterKey];
			if (showInBuyerCountry(filterData)) {
				filterObj[filterKey] = filterData.type.getSelectedValue(filterKey);
			}
		});

		return filterObj;
	};

	const getCurrentFiltersAppliedCount = (group) => {
		if (!group) {
			group = getFilterGroup();
		}

		let appliedFiltersCount = 0;

		Object.keys(filterGroups[group].filters).forEach((filterKey) => {
			let appliedFilters = filterGroups[group].filters[filterKey].children.filter(
				(child) => child.is_selected,
			);
			appliedFiltersCount += appliedFilters.length;
		});

		return appliedFiltersCount;
	};

	const getCurrentPreviewFiltersAppliedCount = (group) => {
		if (!group) {
			group = getFilterGroup();
		}

		let previewAppliedFiltersCount = 0;

		Object.keys(filterGroups[group].filters).forEach((filterKey) => {
			let appliedFilters = filterGroups[group].filters[filterKey].previewChildren.filter(
				(child) => child.is_selected,
			);
			previewAppliedFiltersCount += appliedFilters.length;
		});

		return previewAppliedFiltersCount;
	};

	const disableFilters = () => {
		let group = getFilterGroup();
		Object.keys(filterGroups[group].filters).forEach((filterKey) => {
			let filterData = filterGroups[group].filters[filterKey];
			if (showInBuyerCountry(filterData)) {
				filterData.type.disableFilter(filterKey);
			}
		});
	};

	const enableFilters = () => {
		let group = getFilterGroup();
		Object.keys(filterGroups[group].filters).forEach((filterKey) => {
			let filterData = filterGroups[group].filters[filterKey];
			if (showInBuyerCountry(filterData)) {
				filterData.type.enableFilter(filterKey);
			}
		});
	};

	const closeMobileFiltersModalOnResize = () => {
		$(window).resize(function () {
			if ($(window).width() > 992) {
				$(`#${domElements.filtersModalId}`).modal('hide');
			}
		});
	};

	const stickyHeaderOnMobile = () => {
		let header = $('#list-filters-header');
		let headerAnchor = $('#list-filters-header-anchor');

		if (isActiveTab('matches') && header.length > 0 && headerAnchor.length > 0) {
			let headerOffset = headerAnchor.offset().top;

			if ($(window).width() < 992) {
				toggleStickyHeader(header, headerOffset);
			}
			$(window).scroll(function () {
				if ($(window).width() < 992) {
					toggleStickyHeader(header, headerOffset);
				}
			});
			$(window).resize(function () {
				if ($(window).width() > 992) {
					header.removeClass('sticky');
				} else {
					toggleStickyHeader(header, headerOffset);
				}
			});
			$(window).on('orientationchange', function (event) {
				if ($(window).width() > 992) {
					header.removeClass('sticky');
				} else {
					toggleStickyHeader(header, headerOffset);
				}
			});
		}
	};

	const toggleStickyHeader = ($header, headerOffset) => {
		let scroll = $(window).scrollTop();
		scroll >= headerOffset - 75
			? $header.addClass('sticky')
			: $header.removeClass('sticky');
	};

	const isActiveTab = (tab) => {
		return $('ul#seller-list-tabbed-nav a.active').attr('id') === tab;
	};

	const stickyModalHeader = () => {
		let modalHeader = $(`#${domElements.filtersModalHeaderContainerId}`);
		$(`#${domElements.filtersModalId} .modal-body`).scroll(function () {
			let scroll = $(`#${domElements.filtersModalId} .modal-body`).scrollTop();
			scroll > 0
				? modalHeader.addClass('sticky-border')
				: modalHeader.removeClass('sticky-border');
		});
	};

	const getFiltersHtml = (group, preview = false) => {
		let filtersHtml = [];
		Object.keys(filterGroups[group].filters).forEach((filterKey) => {
			let filterData = filterGroups[group].filters[filterKey];
			if (showInBuyerCountry(filterData)) {
				filtersHtml.push(
					filterData.type.getHtml({
						data: filterData,
						key: filterKey,
						isPreview: preview,
					}),
				);
			}
		});

		return filtersHtml.join('');
	};

	const handleNoFilteredMatches = () => {
		let totalResults = getPaginationTotal();
		let currentAppliedFilters = getCurrentFiltersAppliedCount();
		if (totalResults === 0 && currentAppliedFilters > 0) {
			$('#no-filtered-matches').removeClass('d-none');
			$('#matches-tab .pagination-row-container').empty();
		} else {
			$('#no-filtered-matches').addClass('d-none');
		}
	};

	const setBuyerCountryId = ({ data: { country_id } }) => {
		state.buyerCountryId = country_id;
	};

	const showInBuyerCountry = (filterData) => {
		if (state.buyerCountryId && filterData?.countryIds?.length > 0) {
			return filterData.countryIds.includes(state.buyerCountryId);
		}
		return true;
	};

	const getProjectHash = () => {
		return $('#project-id').val();
	};

	const getPaginationTotal = () => {
		const currentTotal = state.pagination.total;
		const modifier =
			typeof state.paginationModifier !== 'undefined' ? state.paginationModifier : 0;
		const newTotal = currentTotal + modifier;
		return newTotal;
	};

	const getPaginationObject = () => {
		let currentPagination = Object.assign({}, state.pagination);
		currentPagination.total = getPaginationTotal();
		return currentPagination;
	};

	return {
		draw,
		updateData,
		getFilterKeys,
		getCurrentFiltersAndValues,
		getCurrentFiltersAppliedCount,
		updateMobileFiltersPreviewData,
		drawPreviewMobileFiltersModal,
		setBuyerCountryId,
		stickyHeaderOnMobile,
		setPaginationModifier,
	};

}
